// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5190bb3c","258":"9fa65b7d"}[chunkId] + ".chunk.js";
};